import { FC, useEffect, useState } from 'react';
import { CanvasRenderer } from 'echarts/renderers';
import { GaugeChart, PieChart } from 'echarts/charts';
import * as echarts from 'echarts/core';
import ECharts from '@/common/components/Business/ECharts';

echarts.use([
  GaugeChart,
  CanvasRenderer,
  PieChart,
]);


const PPTGaugeChart: FC<any> = ({
  className,
  value,
  title
}) => {
  const [options, setOptions] = useState<any>(null);
  const [ins, setIns] = useState<any>(null);

  useEffect(() => {
    return () => {
      ins && ins.dispose();
    };
  }, [ins]);

  useEffect(() => {
    if (ins && value) {
      initOptions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ins, value]);


  const initOptions = () => {

    const echartsOptions = {
      series: [
        {
          type: 'gauge',
          min: 0,
          z: 1,
          max: 1, // 最大值
          splitNumber: 50,
          progress: {
            show: true,
            width: 18,
            roundCap: true,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: '#50DFEC' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: '#006AFF' // 100% 处的颜色
                  }
                ]
              }
            }
          },
          startAngle: 225,
          endAngle: -45,
          axisLine: {
            roundCap: true,
            lineStyle: {
              width: 20
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            distance: -35,
            lineStyle: {
              color: '#F0F0F0',
              dashoffset: 20
            }
          },
          axisLabel: {
            show: false
          },
          radius: '112',
          anchor: {
            show: false,
          },
          pointer: {
            icon: `image://${require('@/assets/image/gauge_bg.png')}`,
            width: 38,
            length: 29,
            itemStyle: {
              color: '#E25365'
            },
            offsetCenter: [0, -60],
            keepAspect: true,
          },
          center: ['50%', '50%'], // 控制图表显示的位置
          detail: {
            fontFamily: 'PingFangSC-Regular, PingFang SC',
            valueAnimation: true,
            offsetCenter: [0, 0],
            formatter: [`{b|${title || 0}}`, '{a|日均客流指数(人次)}'].join('\n'),
            lineHeight: 23,
            rich: {
              a: {
                color: '#666666',
                fontSize: 16,
                lineHeight: 22
              },
              b: {
                color: '#222222',
                fontSize: 32,
                fontWeight: 'bold',
                lineHeight: 40
              }
            }
          },
          data: [{ value }],
          // ...(config.seriesConfig || {}) // 额外配置
        },
        {
          type: 'pie',
          radius: 50,
          z: 0,
          itemStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0, color: '#EDF5FF'
                },
                {
                  offset: 1, color: '#FFFFFF'
                },
              ]
            }
          },
          data: [1],
          labelLine: {
            show: false,
          }
        }
      ]
    };
    setOptions(echartsOptions);
  };

  const loadedHandle = (ins: any) => {
    ins && setIns(ins);
  };

  return (
    <ECharts
      options={options}
      loadedEchartsHandle={loadedHandle}
      className={className}/>
  );
};

export default PPTGaugeChart;
